/*
  Zettler Digital: Sezzle + Appstle duplicate widget fix.
  Appstle injects its subscription price as a second span.price-item--regular inside .price__regular,
  and Sezzle's product-page targetXPath (.price__regular/.price-item--regular) renders one widget per match.
  When an Appstle subscription price is present, keep only the lowest-amount Sezzle widget (the subscription
  price) per product block and hide the rest. Widgets hidden here are restored when the duplicate goes away
  (e.g. switching back to one-time purchase). Remove once Sezzle's targetXPath is narrowed in the app.
*/
(function () {
  if (window.__zdSezzleDedupe) return;
  window.__zdSezzleDedupe = true;

  var ATTR = 'data-zd-sezzle-dup';

  function amount(el) {
    var m = (el.textContent || '').match(/\d[\d,]*(?:\.\d+)?/g);
    return m ? parseFloat(m[m.length - 1].replace(/,/g, '')) : Infinity;
  }

  function dedupe() {
    var groups = new Map();
    document.querySelectorAll('.sezzle-shopify-info-button').forEach(function (w) {
      if (w.parentElement && w.parentElement.closest('.sezzle-shopify-info-button')) return;
      var scope = w.closest('product-info, .shopify-section') || document.body;
      if (!groups.has(scope)) groups.set(scope, []);
      groups.get(scope).push(w);
    });

    groups.forEach(function (widgets, scope) {
      var keep = null;
      if (scope.querySelector('.appstle_subscription_final_price') && widgets.length > 1) {
        widgets.forEach(function (w) {
          if (!keep || amount(w) < amount(keep)) keep = w;
        });
      }
      widgets.forEach(function (w) {
        var hide = !!keep && w !== keep;
        var hidden = w.hasAttribute(ATTR);
        if (hide && !hidden) {
          w.setAttribute(ATTR, '');
          w.style.display = 'none';
        } else if (!hide && hidden) {
          w.removeAttribute(ATTR);
          w.style.display = '';
        }
      });
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      dedupe();
    });
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
  schedule();
})();
